export const profileSection = {
  Bonuses: "bonuses",
  GameHistory: "gameHistory",
  SportBetsHistory: "sportBetsHistory",
  Wallet: "wallet",
  TransactionHistory: "transactionHistory",
  Info: "info",
  Settings: "settings",
  MemberCard: "memberCard",
} as const;

export const profileSections = Object.values(profileSection);

export type ProfileSection = (typeof profileSection)[keyof typeof profileSection];
